import React from "react";
import "./loader.css";

const Loader = ({ parentStyles = {} }) => {
  return <div className="spinner" style={parentStyles}></div>;
};

export default Loader;
